import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, FormGroup, Form,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label, NavDropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { withRouter } from 'react-router'

import ShopFilterCollapseUnder768 from '../components/ShopFilterCollapseUnder768.js';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopContentUnder768 from '../components/ShopContentUnder768.js';
import ShopContentOver767 from '../components/ShopContentOver767.js';
import ShopItemAddedPopup from '../components/ShopItemAddedPopup.js';

/*
    Pure Maple Products -  Syrup, Cream, Candy, Sugar
    Extra Value Products - Sauces, Beverages, Candy, Jelly, Pancake Mixes, Gift Sets
    Non Maple Products -   Informational, Clothes, Candles, Kitchenware, Books 
*/

class Shop extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired,
    windowWidth: PropTypes.number.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired,
    cartItemCount: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    

    this.state = {
      searchValue: "",
      sortOrder: ["relevance", "-sizeOz"],
      usableProducts: [],
      visibleProducts: [],
      searchProducts: [],
      filterProducts: [],
      productTypeInfo_DictionaryArray: [],
      hasMoreToScroll: true,
      filterOpen: false,
      productCategoryOpen: false,
      pureMapleOpen: false,
      extraValueOpen: false,
      nonMapleOpen: false,
      checked_pureMapleProducts: false,
      checked_extraValueProducts: false,
      checked_nonMapleProducts: false,
      checked_pureSyrup: false,
      checked_pureCream: false,
      checked_pureCandy: false,
      checked_pureSugar: false,
      checked_extraSauces: false,
      checked_extraBeverages: false,
      checked_extraCandy: false,
      checked_extraJelly: false,
      checked_extraGiftSets: false,
      checked_nonPancakeMixes: false,
      checked_nonInformational: false,
      checked_nonClothes: false,
      checked_nonCandles: false,
      checked_nonKitchenware: false,
      checked_nonBooks: false,
      dropdownOpen: false,
      dropdownValue: "Relevance",
      itemAddedPopupOpen: false,
      itemAddedPopupName: "",
      itemAddedPopupQuantity: 0,
      itemAddedPopupImage: "",
      showScrollUpButton: false,
    };
  }

  componentDidMount() {
    this.handleUrlParams();
    this.initializeUsableProducts();
    this.initializeProductTypeInfo();
    this.handleScrolling();
    window.onscroll = () => { this.handleScrolling() }
  }
  componentWillUnmount() {
    window.onscroll = null;
  }

  handleScrolling = () => { 
    if(window.pageYOffset > 300) {  this.setState({ showScrollUpButton: true }) } 
    else { this.setState({ showScrollUpButton: false }) }
  }
  scrollToTop = () => { this.props.scrollToSection("root", -200) }

  handleUrlParams = () => {
    let initialFilter = this.props.match.params.initialFilter;
    if(initialFilter == "giftsets") { this.extraGiftSetsCheck(); }
    if(initialFilter == "books") { this.nonBooksCheck(); }
    if(initialFilter == "sale") { this.setState({ searchValue: "Gallone" }, () => this.setSearchProducts() );  }
  }

  initializeUsableProducts = () => {
    let usableProducts = this.props.products.slice(0).filter(product => product.inSeason && !product.isDiscontinued);
    
    // GETTING PRODUCT LISTING AROUND FOR DANI SECTION 2/25/19
    /*
    usableProducts.map( (product, index) => {
      let csvString = product.name + "," + product.sizeDisplay + "," + product.price + "," + product.isDiscontinued;
      console.log(csvString);
    });
    */
    /*
    this.props.products.map( (product, index) => {
      let csvString = product.name + "," + product.sizeDisplay + "," + product.price + "," + product.isDiscontinued;
      if(product.isDiscontinued == true)
      console.log(csvString);
    });
    */

    this.setState({ usableProducts, searchProducts: usableProducts, filterProducts: usableProducts }, () => this.defaultSortUsableProducts("initial"));
  }

  defaultSortUsableProducts = (origin) => {
    if(origin === "initial" || origin === "setSearch" || origin === "setFilter") {
      let sortedUsableProducts = this.state.usableProducts.sort(this.fieldSorter(this.state.sortOrder));
      this.setState({ usableProducts: sortedUsableProducts }, () => this.setVisibleProducts(origin));
    }
  }

  setVisibleProducts = (origin) => {
    let visibleCount = 12;
    let hasMoreToScroll = true;
    let visibleProducts = []

    // If enough products are left to use the declared visibleCount, do so. Otherwise, just put the amount left into visibleProducts.
    if(this.state.usableProducts.length <= visibleCount) {
      visibleCount = this.state.usableProducts.length;
      hasMoreToScroll = false;
    }

    if(origin === "initial" || origin === "setSearch" || origin === "setFilter" || origin === "dropdownSort") {
      visibleProducts = this.state.usableProducts.slice(0, visibleCount);
      this.setState({ visibleProducts, hasMoreToScroll });
    }
  }

  setSearchProducts = () => {
    let searchProducts = this.props.products;

    if(this.state.searchValue.length > 0) {
      // If the search value is in the product's name, keep that product in the array.
      searchProducts = searchProducts.filter(product => product.name.toUpperCase().includes(this.state.searchValue.toUpperCase()));
    }
    
    this.props.scrollToSection("root", -100);
    this.setState( { searchProducts }, () => this.setUsableProducts("setSearch") )
  }

  setFilterProducts = () => {
    let pureTypeArray = [];
    let extraTypeArray = [];
    let nonTypeArray = [];
    let pureSubTypeArray = [];
    let extraSubTypeArray = [];
    let nonSubTypeArray = [];
    let pure_ARRAY = [];
    let extra_ARRAY = [];
    let non_ARRAY = [];
    let filterProducts = this.props.products;

    // If any filter is checked, create the proper filterProducts array. If none are checked, just return filterProducts as all products.
    if(this.state.checked_pureMapleProducts || this.state.checked_extraValueProducts || this.state.checked_nonMapleProducts || 
       this.state.checked_pureSyrup || this.state.checked_pureCream || this.state.checked_pureCandy || this.state.checked_pureSugar ||
       this.state.checked_extraSauces || this.state.checked_extraBeverages || this.state.checked_extraCandy || this.state.checked_extraJelly ||
       this.state.checked_extraGiftSets || this.state.checked_nonPancakeMixes || this.state.checked_nonInformational || this.state.checked_nonClothes ||
       this.state.checked_nonCandles || this.state.checked_nonKitchenware || this.state.checked_nonBooks) 
    {

      // Create type & subtype very specific arrays. These will be combined into their respective typeArray_All & subTypeArray_All.
      for(let i=0; i<this.props.products.length; i++) {
        let product = this.props.products[i];
        let type = this.props.products[i].type.toUpperCase();
        let subType = this.props.products[i].subType.toUpperCase();

        if(this.state.checked_pureMapleProducts && type === "PURE") {
          // Type Array Push
          pureTypeArray.push(product);
        }

        if(this.state.checked_extraValueProducts && type === "EXTRA") {
          // Type Array Push
          extraTypeArray.push(product);
        }

        if(this.state.checked_nonMapleProducts && type === "NON") {
          // Type Array Push
          nonTypeArray.push(product);
        }

          // SubType Array Pushes
          if(this.state.checked_pureSyrup && subType === "SYRUP") { pureSubTypeArray.push(product); }
          if(this.state.checked_pureCream && subType === "CREAM") { pureSubTypeArray.push(product); }
          if(this.state.checked_pureCandy && subType === "PURECANDY") { pureSubTypeArray.push(product); }
          if(this.state.checked_pureSugar && subType === "SUGAR") { pureSubTypeArray.push(product); }

          if(this.state.checked_extraSauces && subType === "SAUCES") { extraSubTypeArray.push(product); }
          if(this.state.checked_extraBeverages && subType === "BEVERAGES") { extraSubTypeArray.push(product); }
          if(this.state.checked_extraCandy && subType === "EXTRACANDY") { extraSubTypeArray.push(product); }
          if(this.state.checked_extraJelly && subType === "JELLY") { extraSubTypeArray.push(product); }
          if(this.state.checked_extraGiftSets && subType === "GIFTSETS") { extraSubTypeArray.push(product); }

          if(this.state.checked_nonPancakeMixes && subType === "PANCAKEMIXES") { nonSubTypeArray.push(product); }
          if(this.state.checked_nonInformational && subType === "INFORMATIONAL") { nonSubTypeArray.push(product); }
          if(this.state.checked_nonClothes && subType === "CLOTHES") { nonSubTypeArray.push(product); }
          if(this.state.checked_nonCandles && subType === "CANDLES") { nonSubTypeArray.push(product); }
          if(this.state.checked_nonKitchenware && subType === "KITCHENWARE") { nonSubTypeArray.push(product); }
          if(this.state.checked_nonBooks && subType === "BOOKS") { nonSubTypeArray.push(product); }

      }

      // Intersect each specific type array with its subType array to create the _ARRAY arrays.
      // If type & subtype arrays both have values, intersect them. Otherwise, concat them.
      let pure_Intersected;
      if(pureTypeArray.length > 0 && pureSubTypeArray.length > 0) {
        pure_Intersected = new Set(pureTypeArray.filter(x => new Set(pureSubTypeArray).has(x)));
      }
      else {
        pure_Intersected = pureTypeArray.concat(pureSubTypeArray);
      }

      let extra_Intersected;
      if(extraTypeArray.length > 0 && extraSubTypeArray.length > 0) {
        extra_Intersected = new Set(extraTypeArray.filter(x => new Set(extraSubTypeArray).has(x)));
      }
      else {
        extra_Intersected = extraTypeArray.concat(extraSubTypeArray);
      }

      let non_Intersected;
      if(nonTypeArray.length > 0 && nonSubTypeArray.length > 0) {
        non_Intersected = new Set(nonTypeArray.filter(x => new Set(nonSubTypeArray).has(x)));
      }
      else {
        non_Intersected = nonTypeArray.concat(nonSubTypeArray);
      }

      pure_ARRAY = [...pure_Intersected];
      extra_ARRAY = [...extra_Intersected];
      non_ARRAY = [...non_Intersected];

      // Concat all intersected _ARRAY into the final filterProducts array.
      filterProducts = pure_ARRAY.concat(extra_ARRAY, non_ARRAY);
    }

    // Update the "Filters Display" dictionary. This is not related to the rest of the logic in this function much.
    let productTypeInfo_DictionaryArray = this.state.productTypeInfo_DictionaryArray;
    productTypeInfo_DictionaryArray.map((productTypeInfo, index, dictionary) => {
      // Set 'IsActiveFilter' to the current checked state for that filter.
      productTypeInfo.IsActiveFilter = this.state[productTypeInfo.CheckedState];
    })

    this.setState( { filterProducts, productTypeInfo_DictionaryArray }, () => this.setUsableProducts("setFilter") )
  }

  // Only called after a user performs a search or sets a filter. Initial page load does not call this function.
  setUsableProducts = (origin) => {
    let intersectionOfProducts = new Set(this.state.searchProducts.filter(x => new Set(this.state.filterProducts).has(x)));
    let usableProducts = [...intersectionOfProducts];
    
    if(origin === "setSearch" || origin === "setFilter") {
      this.setState({ usableProducts }, () => this.defaultSortUsableProducts(origin));
    }
  }

  setSearchValue = (event) => { 
    this.setState({ searchValue: event.target.value }, () => this.setSearchProducts() ); 
  }

  dropdownSort = (choice) => {
    // Can sort by Relevance, Price low to high, price high to low, date added (newest first), 
    let sortOrder = [];
    switch(choice) {
      case "Relevance":
        sortOrder.push("relevance", "-sizeOz");
        break;
      case "Price (low to high)":
        sortOrder.push("price", "relevance");
        break;
      case "Price (high to low)":
        sortOrder.push("-price", "relevance");
        break;
      case "Date (newest first)":
        sortOrder.push("-dateAdded", "relevance");
        break;
      case "Alphabetical (A-Z)":
        sortOrder.push("name", "price");
        break;
    }
    let sortedUsableProducts = this.state.usableProducts.sort(this.fieldSorter(sortOrder));
    this.setState({ usableProducts: sortedUsableProducts, sortOrder }, () => this.setVisibleProducts("dropdownSort"));
  }

  selectDropdownItem = (event) => { 
    this.setState({ 
      dropdownOpen: !this.state.dropdownOpen, 
      dropdownValue: event.target.innerText 
    }); 
    
    this.dropdownSort(event.target.innerText);
  }

  toggleDropdownOpen = () => { this.setState({ dropdownOpen: !this.state.dropdownOpen }); }

  loadMoreScroll = () => {
    let visibleProducts = this.state.visibleProducts.slice(0);
    let visibleCount = this.state.visibleProducts.length;
    let startIterator = visibleCount;
    let amountToLoad = 12;
    let hasMoreToScroll = true;

    if(visibleCount + amountToLoad >= this.state.usableProducts.length) {
      amountToLoad = this.state.usableProducts.length - visibleCount;
      hasMoreToScroll = false;
    }

    visibleCount += amountToLoad;

    for(let i=startIterator; i<visibleCount; i++) {
      visibleProducts.push(this.state.usableProducts[i]);
    }

    this.setState({ visibleProducts, hasMoreToScroll });
  }

  toggleFilter = () => { this.setState({filterOpen: !this.state.filterOpen}); }

  toggleProductCategory = () => { this.setState({productCategoryOpen: !this.state.productCategoryOpen}); }
  togglePureMaple = () => { this.setState({pureMapleOpen: !this.state.pureMapleOpen} ); }
  toggleExtraValue = () => { this.setState({extraValueOpen: !this.state.extraValueOpen}); }
  toggleNonMaple = () => { this.setState({nonMapleOpen: !this.state.nonMapleOpen}); }

  pureMapleCheck = () => { this.setState({checked_pureMapleProducts: !this.state.checked_pureMapleProducts}, () => this.setFilterProducts() ); }
  extraValueCheck = () => { this.setState({checked_extraValueProducts: !this.state.checked_extraValueProducts}, () => this.setFilterProducts() ); }
  nonMapleCheck = () => { this.setState({checked_nonMapleProducts: !this.state.checked_nonMapleProducts}, () => this.setFilterProducts() ); }
  pureSyrupCheck = () => { this.setState({checked_pureSyrup: !this.state.checked_pureSyrup}, () => this.setFilterProducts() ); }
  pureCreamCheck = () => { this.setState({checked_pureCream: !this.state.checked_pureCream}, () => this.setFilterProducts() ); }
  pureCandyCheck = () => { this.setState({checked_pureCandy: !this.state.checked_pureCandy}, () => this.setFilterProducts() ); }
  pureSugarCheck = () => { this.setState({checked_pureSugar: !this.state.checked_pureSugar}, () => this.setFilterProducts() ); }
  extraSaucesCheck = () => { this.setState({checked_extraSauces: !this.state.checked_extraSauces}, () => this.setFilterProducts() ); }
  extraBeveragesCheck = () => { this.setState({checked_extraBeverages: !this.state.checked_extraBeverages}, () => this.setFilterProducts() ); }
  extraCandyCheck = () => { this.setState({checked_extraCandy: !this.state.checked_extraCandy}, () => this.setFilterProducts() ); }
  extraJellyCheck = () => { this.setState({checked_extraJelly: !this.state.checked_extraJelly}, () => this.setFilterProducts() ); }
  extraGiftSetsCheck = () => { this.setState({checked_extraGiftSets: !this.state.checked_extraGiftSets}, () => this.setFilterProducts() ); }
  nonPancakeMixesCheck = () => { this.setState({checked_nonPancakeMixes: !this.state.checked_nonPancakeMixes}, () => this.setFilterProducts() ); }
  nonInformationalCheck = () => { this.setState({checked_nonInformational: !this.state.checked_nonInformational}, () => this.setFilterProducts() ); }
  nonClothesCheck = () => { this.setState({checked_nonClothes: !this.state.checked_nonClothes}, () => this.setFilterProducts() ); }
  nonCandlesCheck = () => { this.setState({checked_nonCandles: !this.state.checked_nonCandles}, () => this.setFilterProducts() ); }
  nonKitchenwareCheck = () => { this.setState({checked_nonKitchenware: !this.state.checked_nonKitchenware}, () => this.setFilterProducts() ); }
  nonBooksCheck = () => { this.setState({checked_nonBooks: !this.state.checked_nonBooks}, () => this.setFilterProducts() ); }

  initializeProductTypeInfo = () => {
    let productTypeInfo_DictionaryArray = 
    [
      {
        "FilterDisplay": "Pure Maple",
        "CheckedState": "checked_pureMapleProducts",
        "CheckedFunction": "pureMapleCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Extra Value",
        "CheckedState": "checked_extraValueProducts",
        "CheckedFunction": "extraValueCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Non Maple",
        "CheckedState": "checked_nonMapleProducts",
        "CheckedFunction": "nonMapleCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Pure Maple Syrup",
        "CheckedState": "checked_pureSyrup",
        "CheckedFunction": "pureSyrupCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Pure Maple Cream",
        "CheckedState": "checked_pureCream",
        "CheckedFunction": "pureCreamCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Pure Maple Candy",
        "CheckedState": "checked_pureCandy",
        "CheckedFunction": "pureCandyCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Pure Maple Sugar",
        "CheckedState": "checked_pureSugar",
        "CheckedFunction": "pureSugarCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Sauces",
        "CheckedState": "checked_extraSauces",
        "CheckedFunction": "extraSaucesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Beverages",
        "CheckedState": "checked_extraBeverages",
        "CheckedFunction": "extraBeveragesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Extra Value Candy",
        "CheckedState": "checked_extraCandy",
        "CheckedFunction": "extraCandyCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Jelly",
        "CheckedState": "checked_extraJelly",
        "CheckedFunction": "extraJellyCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Gift Sets",
        "CheckedState": "checked_extraGiftSets",
        "CheckedFunction": "extraGiftSetsCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Pancake Mixes",
        "CheckedState": "checked_nonPancakeMixes",
        "CheckedFunction": "nonPancakeMixesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Informational",
        "CheckedState": "checked_nonInformational",
        "CheckedFunction": "nonInformationalCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Clothes",
        "CheckedState": "checked_nonClothes",
        "CheckedFunction": "nonClothesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Candles",
        "CheckedState": "checked_nonCandles",
        "CheckedFunction": "nonCandlesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Candles",
        "CheckedState": "checked_nonCandles",
        "CheckedFunction": "nonCandlesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Kitchenware",
        "CheckedState": "checked_nonKitchenware",
        "CheckedFunction": "nonKitchenwareCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Books",
        "CheckedState": "checked_nonBooks",
        "CheckedFunction": "nonBooksCheck",
        "IsActiveFilter": false
      }
  ]

    this.setState({ productTypeInfo_DictionaryArray });
  }

  addItemToCart = (id, name, price, url, size, sizeDisplay, image) => {
    let quantity = Number(document.getElementById("quantity" + id).value);
    
    this.props.addItemToCartState(quantity, price*quantity);

    if(quantity == null || quantity < 1 || quantity == "") { quantity = 1; }
    if(Number(price) < 1) { price = Number(price); }
    
    name = `${name}: ${sizeDisplay}`;

    // If this item being added is a gift card, add additional custom fields to enter: 
    // The amount, who it is going to, the address, and if they want anything on the tag.
    switch(id) {
      case 353:
        window.Snipcart.api.items.add({
          "id": id,
          "name": name,
          "price": price,
          "url": url,
          "weight": size,
          "quantity": quantity,
          "image": image,
          "customFields": [
          {
              "name": "Gift Card Amount",
              "options": "$20|$30[+10.00]|$40[+20.00]|$50[+30.00]|$60[+40.00]|$75[+55.00]|$100[+80.00]|$150[+130.00]|$200[+180.00]|$250[+230.00]",
              "type": "dropdown",
              "value": "$20",
              "required": true
          },
          {
              "name": "Is this a gift?",
              "options": "true|false",
              "type": "checkbox",
              "value": "false",
              "required": false
          },
          {
              "name": "Recipient Name (If Gift)",
              "options": "",
              "type": "textbox",
              "value": "",
              "required": false
           },
          {
              "name": "Recipient Address (If Gift)",
              "options": "",
              "type": "textbox",
              "value": "",
              "required": false
           },
          {
              "name": "Words on Card (If Gift)",
              "options": "",
              "type": "textarea",
              "value": "",
              "required": false
           },
          {
              "name": "Corn-free packaging",
              "options": "Yes|No",
              "type": "dropdown",
              "value": "No",
              "required": false
          }
          ]
        });
        break;
      default:
        window.Snipcart.api.items.add({
          "id": id,
          "name": name,
          "price": price,
          "url": url,
          "weight": size,
          "quantity": quantity,
          "image": image,
          "customFields": 
          [
            {
                "name": "Is this a gift?",
                "options": "true|false",
                "type": "checkbox",
                "value": "false",
                "required": false
            },
            {
                "name": "Recipient Name (If Gift)",
                "options": "",
                "type": "textbox",
                "value": "",
                "required": false
             },
            {
                "name": "Recipient Address (If Gift)",
                "options": "",
                "type": "textbox",
                "value": "",
                "required": false
             },
            {
                "name": "Words on Gift (If Gift)",
                "options": "",
                "type": "textarea",
                "value": "",
                "required": false
             },
            {
                "name": "Corn-free packaging",
                "options": "Yes|No",
                "type": "dropdown",
                "value": "No",
                "required": false
            }
           ]
        });
    }

    this.itemAddedPopup(name, quantity, image);
  }

  itemAddedPopup = (name, quantity, image) => {
    this.setState({
      itemAddedPopupName: name,
      itemAddedPopupQuantity: quantity,
      itemAddedPopupImage: image,
      itemAddedPopupOpen: true
    });
  }
  itemAddedPopupClosing = () => { this.setState({itemAddedPopupOpen: false}); }

  onAfterOpen = () => { 
    document.getElementsByTagName("button").onclick = 
    (() => {
      document.getElementByClassName("sa-success").addClass("hide");
      setTimeout(() =>  {
        document.getElementByClassName("sa-success").removeClass("hide");
      }, 10);
    });

    this.setState({itemAddedPopupOpen: false}); 
  }


  fieldSorter = (fields) => {
    return (a, b) => fields.map(o => {
        let dir = 1;
        if (o[0] === '-') { dir = -1; o=o.substring(1); }
        return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
    }).reduce((p,n) => p ? p : n, 0);
  }

  render() {

    return (

      	<FluidContainer fluid>
          <Helmet>
            <title>Shop Pure Maple - Patterson Maple Farms</title>
          </Helmet>
        
          {
            this.props.windowWidth < 768 
            ? 
            <ShopFilterCollapseUnder768 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
              toggleProductCategory={this.toggleProductCategory} togglePureMaple={this.togglePureMaple}
              toggleExtraValue={this.toggleExtraValue} toggleNonMaple={this.toggleNonMaple}
              pureMapleCheck={this.pureMapleCheck} extraValueCheck={this.extraValueCheck} nonMapleCheck={this.nonMapleCheck}
              pureSyrupCheck={this.pureSyrupCheck} pureCreamCheck={this.pureCreamCheck} pureCandyCheck={this.pureCandyCheck} pureSugarCheck={this.pureSugarCheck}
              extraSaucesCheck={this.extraSaucesCheck} extraBeveragesCheck={this.extraBeveragesCheck} extraCandyCheck={this.extraCandyCheck}
              extraJellyCheck={this.extraJellyCheck} extraGiftSetsCheck={this.extraGiftSetsCheck}
              nonPancakeMixesCheck={this.nonPancakeMixesCheck} nonInformationalCheck={this.nonInformationalCheck} nonClothesCheck={this.nonClothesCheck} 
              nonCandlesCheck={this.nonCandlesCheck} nonKitchenwareCheck={this.nonKitchenwareCheck} nonBooksCheck={this.nonBooksCheck}
              {...this.state} 
              /> 
            : ""

          }
          {
            this.props.windowWidth < 768
            ? 
              <ShopContentUnder768 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
                products={this.props.products} usableProducts={this.state.usableProducts} 
                visibleProducts={this.state.visibleProducts} productTypeInfo_DictionaryArray={this.state.productTypeInfo_DictionaryArray} 
                setSearchValue={this.setSearchValue} searchValue={this.state.searchValue} 
                hasMoreToScroll={this.state.hasMoreToScroll} loadMoreScroll={this.loadMoreScroll}
                togglePureMaple={this.togglePureMaple}
                toggleExtraValue={this.toggleExtraValue} toggleNonMaple={this.toggleNonMaple}
                pureMapleCheck={this.pureMapleCheck} extraValueCheck={this.extraValueCheck} nonMapleCheck={this.nonMapleCheck}
                pureSyrupCheck={this.pureSyrupCheck} pureCreamCheck={this.pureCreamCheck} pureCandyCheck={this.pureCandyCheck} pureSugarCheck={this.pureSugarCheck}
                extraSaucesCheck={this.extraSaucesCheck} extraBeveragesCheck={this.extraBeveragesCheck} extraCandyCheck={this.extraCandyCheck}
                extraJellyCheck={this.extraJellyCheck} extraGiftSetsCheck={this.extraGiftSetsCheck}
                nonPancakeMixesCheck={this.nonPancakeMixesCheck} nonInformationalCheck={this.nonInformationalCheck} nonClothesCheck={this.nonClothesCheck} 
                nonCandlesCheck={this.nonCandlesCheck} nonKitchenwareCheck={this.nonKitchenwareCheck} nonBooksCheck={this.nonBooksCheck}
                addItemToCart={this.addItemToCart} addItemToCartState={this.props.addItemToCartState} cartItemCount={this.props.cartItemCount}
                dropdownSort={this.dropdownSort} selectDropdownItem={this.selectDropdownItem} 
                dropdownOpen={this.state.dropdownOpen} dropdownValue={this.state.dropdownValue} toggleDropdownOpen={this.toggleDropdownOpen}
                scrollToTop={this.scrollToTop} showScrollUpButton={this.state.showScrollUpButton}
              {...this.state} 
                /> 
            : ""
          }

          {
            this.props.windowWidth > 767
            ? 
              <ShopContentOver767 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
                products={this.props.products} usableProducts={this.state.usableProducts} 
                visibleProducts={this.state.visibleProducts} productTypeInfo_DictionaryArray={this.state.productTypeInfo_DictionaryArray}
                setSearchValue={this.setSearchValue} searchValue={this.state.searchValue}
                hasMoreToScroll={this.state.hasMoreToScroll} loadMoreScroll={this.loadMoreScroll}
                toggleProductCategory={this.toggleProductCategory} togglePureMaple={this.togglePureMaple}
                toggleExtraValue={this.toggleExtraValue} toggleNonMaple={this.toggleNonMaple}
                pureMapleCheck={this.pureMapleCheck} extraValueCheck={this.extraValueCheck} nonMapleCheck={this.nonMapleCheck}
                pureSyrupCheck={this.pureSyrupCheck} pureCreamCheck={this.pureCreamCheck} pureCandyCheck={this.pureCandyCheck} pureSugarCheck={this.pureSugarCheck}
                extraSaucesCheck={this.extraSaucesCheck} extraBeveragesCheck={this.extraBeveragesCheck} extraCandyCheck={this.extraCandyCheck}
                extraJellyCheck={this.extraJellyCheck} extraGiftSetsCheck={this.extraGiftSetsCheck}
                nonPancakeMixesCheck={this.nonPancakeMixesCheck} nonInformationalCheck={this.nonInformationalCheck} nonClothesCheck={this.nonClothesCheck} 
                nonCandlesCheck={this.nonCandlesCheck} nonKitchenwareCheck={this.nonKitchenwareCheck} nonBooksCheck={this.nonBooksCheck} 
                scrollToSection={this.props.scrollToSection} addItemToCart={this.addItemToCart} addItemToCartState={this.props.addItemToCartState}
                dropdownSort={this.dropdownSort} selectDropdownItem={this.selectDropdownItem} 
                dropdownOpen={this.state.dropdownOpen} dropdownValue={this.state.dropdownValue} toggleDropdownOpen={this.toggleDropdownOpen}
                scrollToTop={this.scrollToTop} showScrollUpButton={this.state.showScrollUpButton}
                {...this.state}
                /> 
            : ""
          }

        <ShopItemAddedPopup itemAddedPopupName={this.state.itemAddedPopupName} itemAddedPopupQuantity={this.state.itemAddedPopupQuantity}
                            itemAddedPopupImage={this.state.itemAddedPopupImage} itemAddedPopupOpen={this.state.itemAddedPopupOpen}
                            onAfterOpen={this.onAfterOpen} itemAddedPopupClosing={this.itemAddedPopupClosing} />
        </FluidContainer>
		);
	}
}

export default withRouter(Shop);

const FluidContainer = styled(Container)`
  padding: 20px 0 20px 0!important;
`;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/pages/Shop.js